import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import { Field, Form } from 'react-final-form'
import {
  FormControlLabel,
  InputAdornment,
  IconButton,
  MenuItem,
  Button,
  Icon,
} from '@material-ui/core'
import isEqual from 'lodash/isEqual'
import cn from 'classnames'
import isEmpty from 'lodash.isempty'
import withPromise from 'helpers/withPromise'
import { Checkbox } from 'components/common/FormInputs'
import FinalFormMultipleSelect from 'components/common/Form/FinalFormMultipleSelect'
import TimePickerInput from 'components/common/Form/TimePicker'
import SelectInput from 'components/common/Form/SelectInput'
import TextArea from 'components/common/Form/TextArea'
import Input from 'components/common/Form/Input'
import {
  saveEventForm,
  fetchEventDataList,
  fetchLocusGroupsList,
  clearEventDataItem,
  fetchEventDataItem,
} from 'reducers/logbook/reducer'
import { uploadFiles, removeFiles } from 'reducers/common/files/reducer'
import { showNotice } from 'reducers/notice'
import NoticeHelper from 'helpers/notice'
import { fetchActiveCages } from 'reducers/digitalLogbook/reducer'
import {
  TYPE_LIST,
  TYPE_INPUT_NUMBER,
  TYPE_MULTIPLE,
  TYPE_INPUT_BOOLEAN,
  TYPE_INPUT_FILE,
  TYPE_INPUT_TEXTAREA,
  TYPE_INPUT_TEXT,
  TYPE_INPUT_DATE,
  getFileObject,
  ifLogbookConstant,
} from 'helpers/logbook'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import DatePickerInput from 'components/common/Form/DatePicker'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import messages from '../translate'

class Details extends Component {
  constructor(props) {
    super(props)
    const now = moment()
    this.state = {
      id: null,
      event_date: now,
      start_time: now,
      end_time: now,
      category: null,
      event: null,
      result: null,
      locus: null,
      locus_group: null,
      comment: '',
      file: getFileObject(),
      slaves: {},
      savingData: false,
    }
  }

  componentDidUpdate(prevProps) {
    const { eventForm } = this.props
    const currentEventForm = eventForm.toJS()
    const prevEventForm = prevProps.eventForm.toJS()

    if (!isEqual(prevEventForm, currentEventForm)) {
      this.setEventInfoState(eventForm)
    }
  }

  componentWillUnmount() {
    this.props.clearEventDataItem()
  }

  setEventInfoState = eventForm => {
    if (!eventForm.size) {
      return false
    }

    const {
      id: formId,
      event_date,
      start_time,
      end_time,
      result,
      locus,
      locus_group,
      comment,
      file,
      slaves,
      event: { id: evtId, category_id },
    } = eventForm.toJS()

    this.setState({
      id: formId,
      event_date: moment(event_date, 'YYYY-MM-DD'),
      start_time: moment(`${event_date} ${start_time}`, 'YYYY-MM-DD HH:mm:ss'),
      end_time: moment(`${event_date} ${end_time}`, 'YYYY-MM-DD HH:mm:ss'),
      category: category_id,
      event: evtId,
      result,
      locus: locus ? locus.id : null,
      locus_group: locus_group ? locus_group.id : null,
      comment,
      file: file || getFileObject(),
    })

    if (slaves && slaves.length > 0) {
      const slaveEvents = slaves.reduce((total, currentItem) => {
        // eslint-disable-next-line no-param-reassign
        total[currentItem.event.title] = currentItem.result

        return total
      }, {})

      this.setState({
        slaves: { ...slaveEvents },
      })
    }
  }

  onEventStartTimeChange = time => {
    if (time) {
      this.setState({ start_time: moment(time) })
    }
  }

  onEventEndTimeChange = time => {
    if (time) {
      this.setState({ end_time: moment(time) })
    }
  }

  onResultSelectChange = (event, slaveName = null) => {
    const { value } = event.target

    if (slaveName) {
      return this.setState(prevState => ({
        slaves: {
          ...prevState.slaves,
          [slaveName]: value,
        },
      }))
    }

    this.setState({ result: value })
  }

  onResultKeyUp = (event, slaveName = null) => {
    let { value } = event.target

    if (value !== '-' && !/^-?[0-9]{1,10}(.[0-9]{0,2})?$/.test(value)) {
      const eventInfo = this.props.eventForm.get('event')
      const digit = 10 ** (eventInfo ? eventInfo.parameters.decimals : 2)
      value = parseFloat(value)
      // eslint-disable-next-line no-restricted-globals
      value = isNaN(value) ? 0 : Math.round(value * digit) / digit
    }

    if (slaveName) {
      return this.setState(prevState => ({
        slaves: {
          ...prevState.slaves,
          [slaveName]: value,
        },
      }))
    }

    this.setState({ result: value })
  }

  formatDigitValue = value => {
    if (value === undefined || value === null || value === '0') return 0
    if (value === '-' || value === '-0' || value === '-0.') return value
    if (value === '-.') return '-0.'
    if (value === '0-') return '-'

    const lastKey = String(value).slice(-1)
    const oldValue = String(value).slice(0, -1)

    if (/^[0-9.]$/.test(lastKey)) {
      return value
    }

    return oldValue
  }

  onDateChange = (date, slaveName = null) => {
    const selectedDate = moment(date).format('YYYY-MM-DD')

    if (slaveName) {
      return this.setState(prevState => ({
        slaves: {
          ...prevState.slaves,
          [slaveName]: selectedDate,
        },
      }))
    }

    this.setState({
      result: selectedDate,
    })
  }

  onCommentChange = (event, slaveName = null) => {
    const { value } = event.target

    if (slaveName) {
      return this.setState(prevState => ({
        slaves: {
          ...prevState.slaves,
          [slaveName]: value,
        },
      }))
    }

    this.setState({ comment: value })
  }

  onTextFieldChange = (event, slaveName = null) => {
    const { value } = event.target

    if (slaveName) {
      return this.setState(prevState => ({
        slaves: {
          ...prevState.slaves,
          [slaveName]: value,
        },
      }))
    }

    this.setState({ result: value })
  }

  onChangeFile = e => {
    const {
      showNotice,
      uploadFiles,
      intl: { formatMessage },
    } = this.props
    const [file] = e.currentTarget.files

    const fileForm = new FormData()
    fileForm.append('file', file)

    withPromise(uploadFiles, {
      file: fileForm,
      formatMessage,
    }).then(response => {
      if (response.error) {
        showNotice({
          notice: NoticeHelper.createErrorObj(
            formatMessage(messages.fileNotUploadMessage),
          ),
        })
      } else {
        this.setState({
          file: response,
        })
      }
    })
  }

  onRemoveFile = () => {
    this.setState({
      file: getFileObject(),
    })
  }

  onCancelForm = () => {
    const { eventForm, cancelEditing } = this.props

    cancelEditing()
    this.setEventInfoState(eventForm)
  }

  getResultFieldByType = (name, formProps) => {
    const {
      intl: { formatMessage },
      isEditable,
    } = this.props
    const {
      event: { options, type, unit },
    } = formProps

    switch (type) {
      case TYPE_INPUT_NUMBER:
        return (
          <Field
            key={name}
            disabled={!isEditable}
            name={name}
            type="text"
            label={formatMessage({ id: name })}
            component={Input}
            className="form-control"
            onKeyUp={event => this.onResultKeyUp(event, name)}
            format={this.formatDigitValue}
            validate={getValidator(VALIDATOR_IS_EMPTY)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {ifLogbookConstant(formatMessage)(unit)}
                </InputAdornment>
              ),
            }}
          />
        )

      case TYPE_INPUT_BOOLEAN:
        return (
          <div className="form-group checkbox-control">
            <FormControlLabel
              key={name}
              label={formatMessage({ id: name })}
              disabled={!isEditable}
              control={
                <Field
                  name={name}
                  type="checkbox"
                  color="primary"
                  component={Checkbox}
                />
              }
            />
          </div>
        )

      case TYPE_LIST:
        return (
          <Field
            key={name}
            name={name}
            component={SelectInput}
            disabled={!isEditable}
            label={formatMessage({ id: name })}
            formControlProps={{
              fullWidth: true,
            }}
            onChange={event => this.onResultSelectChange(event, name)}>
            {Object.keys(options).map(item => (
              <MenuItem
                button
                key={`key_${item}`}
                component="li"
                value={
                  // eslint-disable-next-line no-restricted-globals
                  !isNaN(item) && Number.isInteger(parseFloat(item))
                    ? options[item]
                    : item
                }>
                {ifLogbookConstant(formatMessage)(options[item])}
              </MenuItem>
            ))}
          </Field>
        )

      case TYPE_MULTIPLE:
        return (
          <div className="form-group">
            <Field
              key={name}
              name={name}
              format={value => (Array.isArray(value) ? value : [])}
              component={FinalFormMultipleSelect}
              disabled={!isEditable}
              data={Object.keys(options)}
              label={formatMessage({ id: name })}
              validate={getValidator(VALIDATOR_IS_EMPTY)}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </div>
        )

      case TYPE_INPUT_DATE:
        return (
          <Field
            autoOk
            key={name}
            name={name}
            type="text"
            disabled={!isEditable}
            label={formatMessage({ id: name })}
            component={DatePickerInput}
            onChange={event => this.onDateChange(event, name)}
          />
        )

      case TYPE_INPUT_TEXT:
        return (
          <Field
            key={name}
            disabled={!isEditable}
            name={name}
            type="text"
            label={formatMessage({ id: name })}
            component={Input}
            className="form-control"
            validate={getValidator(VALIDATOR_IS_EMPTY)}
            InputProps={{
              onChange: event => this.onTextFieldChange(event, name),
            }}
          />
        )
      default:
        return null
    }
  }

  getSlaveEvents = (options = []) => {
    if (options.length) {
      return options.map(slave => {
        const { event } = slave

        return this.getResultFieldByType(event.title, slave)
      })
    }

    return null
  }

  onSubmit = values => {
    const {
      saveEventForm,
      fetchEventDataList,
      fetchEventDataItem,
      activeSite,
      activeDateRange,
      eventForm,
      cancelEditing,
      storePsfs,
    } = this.props
    const evtForm = eventForm.toJS()
    const eventInfo = evtForm.event
    const { startDate, endDate } = activeDateRange.toJS()
    const { slaves } = this.state
    const slaveExist =
      evtForm.slaves && evtForm.slaves.length && slaves && !isEmpty(slaves)
    const form = {
      start_time: null,
      end_time: null,
      locus: null,
      locus_group: null,
      comment: null,
      file: null,
    }

    if (
      eventInfo.type !== TYPE_INPUT_FILE &&
      eventInfo.type !== TYPE_INPUT_TEXTAREA
    ) {
      form.result = values.result
    }

    if (eventInfo.type === TYPE_INPUT_NUMBER) {
      form.result = parseFloat(values.result)
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(form.result)) {
        form.result = 0
      }
    }

    if (eventInfo.needs_start_time)
      form.start_time = values.start_time.format('HH:mm:ss')

    if (eventInfo.needs_end_time)
      form.end_time = values.end_time.format('HH:mm:ss')

    if (eventInfo.needs_locus_group) form.locus_group = values.locus_group

    if (eventInfo.needs_locus) form.locus = values.locus

    if (eventInfo.needs_comment || eventInfo.type === TYPE_INPUT_TEXTAREA)
      form.comment = values.comment

    if (eventInfo.needs_file || eventInfo.type === TYPE_INPUT_FILE)
      form.file = values.file.id

    if (slaveExist) {
      const { slaves: masterSlave } = evtForm
      const slaveResult = masterSlave.reduce((total, { event, result, id }) => {
        for (const key in slaves) {
          if (
            Object.prototype.hasOwnProperty.call(slaves, key) &&
            event.title === key &&
            result !== slaves[key]
          ) {
            total.push(
              new Promise((resolve, reject) => {
                resolve(
                  saveEventForm(
                    {
                      form: {
                        locus: form.locus,
                        locus_group: form.locus_group,
                        result: slaves[key],
                      },
                      id: { event: id },
                    },
                    { resolve, reject },
                  ),
                )
              }),
            )
          }
        }

        return total
      }, [])

      return Promise.allSettled(slaveResult).then(() => {
        cancelEditing()
        fetchEventDataList({
          psfs: storePsfs,
          params: {
            site: activeSite,
            from: startDate.format('YYYY-MM-DD'),
            to: endDate.format('YYYY-MM-DD'),
          },
        })
        fetchEventDataItem({ id: values.id })
      })
    }

    return withPromise(saveEventForm, {
      form,
      id: { event: values.id },
    }).then(response => {
      if (Object.prototype.hasOwnProperty.call(response, 'errors')) {
        this.setEventInfoState(eventForm)

        return Promise.resolve(response.errors)
      }

      cancelEditing()
      fetchEventDataList({
        psfs: storePsfs,
        params: {
          site: activeSite,
          from: startDate.format('YYYY-MM-DD'),
          to: endDate.format('YYYY-MM-DD'),
        },
      })
      fetchEventDataItem({ id: values.id })
    })
  }

  render() {
    const {
      eventForm,
      isEditable,
      intl: { formatMessage },
    } = this.props
    const { file, slaves } = this.state
    const initValues = { ...this.state, ...slaves }

    if (!eventForm.size) {
      return null
    }

    const evtForm = eventForm.toJS()
    const { event, slaves: slaveList = [] } = evtForm
    const { options } = event
    const isMasterEvent = !!slaveList.length
    const startTimeLabel = formatMessage(
      event.needs_start_time && event.needs_end_time
        ? messages.startTime
        : messages.time,
    )

    return (
      <Form
        onSubmit={this.onSubmit}
        initialValues={initValues}
        render={({ handleSubmit }) => (
          <form
            onSubmit={handleSubmit}
            className={cn('event-details-form', {
              'readonly-form': !isEditable,
            })}>
            {event.needs_start_time && (
              <Field
                name="start_time"
                type="text"
                disabled={!isEditable}
                label={startTimeLabel}
                component={TimePickerInput}
                onChange={this.onEventStartTimeChange}
              />
            )}

            {event.needs_end_time && (
              <Field
                name="end_time"
                type="text"
                disabled={!isEditable}
                label={formatMessage(messages.endTime)}
                component={TimePickerInput}
                onChange={this.onEventEndTimeChange}
              />
            )}

            {event.type === TYPE_LIST && (
              <Field
                name="result"
                component={SelectInput}
                disabled={!isEditable || isMasterEvent}
                label={formatMessage(messages.result)}
                formControlProps={{
                  fullWidth: true,
                }}
                onChange={evt => this.onResultSelectChange(evt)}>
                {Object.keys(options).map(item => (
                  <MenuItem
                    button
                    key={`key_${item}`}
                    component="li"
                    value={
                      // eslint-disable-next-line no-restricted-globals
                      !isNaN(item) && Number.isInteger(parseFloat(item))
                        ? options[item]
                        : item
                    }>
                    {ifLogbookConstant(formatMessage)(options[item])}
                  </MenuItem>
                ))}
              </Field>
            )}

            {event.type === TYPE_MULTIPLE && (
              <div className="form-group">
                <Field
                  name="result"
                  format={value => (Array.isArray(value) ? value : [])}
                  component={FinalFormMultipleSelect}
                  disabled={!isEditable || isMasterEvent}
                  data={Object.keys(options)}
                  label={formatMessage(messages.result)}
                  validate={getValidator(VALIDATOR_IS_EMPTY)}
                  formControlProps={{
                    fullWidth: true,
                  }}
                />
              </div>
            )}

            {event.type === TYPE_INPUT_BOOLEAN && (
              <div className="form-group checkbox-control">
                <FormControlLabel
                  label={formatMessage(messages.result)}
                  disabled={!isEditable || isMasterEvent}
                  control={
                    <Field
                      name="result"
                      type="checkbox"
                      color="primary"
                      component={Checkbox}
                    />
                  }
                />
              </div>
            )}

            {event.type === TYPE_INPUT_TEXT && (
              <Field
                disabled={!isEditable || isMasterEvent}
                name="result"
                type="text"
                label={formatMessage(messages.result)}
                component={Input}
                className="form-control"
                validate={getValidator(VALIDATOR_IS_EMPTY)}
                InputProps={{
                  onChange: this.onTextFieldChange,
                }}
              />
            )}

            {event.type === TYPE_INPUT_NUMBER && (
              <Field
                disabled={!isEditable || isMasterEvent}
                name="result"
                type="text"
                label={formatMessage(messages.result)}
                component={Input}
                className="form-control"
                onKeyUp={this.onResultKeyUp}
                format={this.formatDigitValue}
                validate={getValidator(VALIDATOR_IS_EMPTY)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {ifLogbookConstant(formatMessage)(event.unit)}
                    </InputAdornment>
                  ),
                }}
              />
            )}

            {event.type === TYPE_INPUT_DATE && (
              <Field
                autoOk
                disabled={!isEditable || isMasterEvent}
                name="result"
                type="text"
                label={formatMessage(messages.result)}
                component={DatePickerInput}
                onChange={this.onDateChange}
              />
            )}

            {(event.needs_comment || event.type === TYPE_INPUT_TEXTAREA) && (
              <Field
                multiline
                disabled={!isEditable || isMasterEvent}
                name="comment"
                label={formatMessage(messages.comment)}
                component={TextArea}
                inputProps={{
                  onChange: this.onCommentChange,
                  rows: 2,
                }}
              />
            )}

            {(event.needs_file || event.type === TYPE_INPUT_FILE) && (
              <div className="form-group">
                <div className="event-file-label">
                  {formatMessage({ id: event.title })}
                </div>
                <div className="event-file-change">
                  {Boolean(file.id) && (
                    <div className="event-file-uploaded">
                      <a
                        href={file.uri}
                        target="_blank"
                        rel="noopener noreferrer">
                        <Icon>attach_file</Icon>
                        <span className="file-name" title={file.originalName}>
                          {file.originalName}
                        </span>
                      </a>
                      {isEditable && (
                        <IconButton
                          className="file-reset"
                          size="small"
                          onClick={this.onRemoveFile}>
                          <Icon>clear</Icon>
                        </IconButton>
                      )}
                    </div>
                  )}
                  {!file.id && (
                    <>
                      <label className="file-upload-area" htmlFor="eventFile">
                        <Icon>description</Icon>
                        {formatMessage(messages.uploadPdfPngJpg)}
                      </label>
                      <input
                        hidden
                        id="eventFile"
                        type="file"
                        onChange={this.onChangeFile}
                      />
                    </>
                  )}
                </div>
              </div>
            )}

            {this.getSlaveEvents(evtForm.slaves)}

            {isEditable && (
              <div className="form-button-group">
                <Button
                  href={null}
                  type="button"
                  color="default"
                  size="medium"
                  variant="contained"
                  onClick={this.onCancelForm}
                  className="cancel-event-btn"
                  fullWidth={ifWindowWidthLessThan(599)}>
                  {formatMessage(messages.cancel)}
                </Button>
                <Button
                  href={null}
                  type="submit"
                  color="primary"
                  size="medium"
                  variant="contained"
                  onClick={handleSubmit}
                  className="save-event-btn"
                  fullWidth={ifWindowWidthLessThan(599)}>
                  {formatMessage(messages.save)}
                </Button>
              </div>
            )}
          </form>
        )}
      />
    )
  }
}

export default connect(
  state => ({
    locusList: state.getIn(['locus', 'listData']),
    locusGroupList: state.getIn(['logbook', 'locusGroupList']),
  }),
  {
    fetchActiveCages,
    saveEventForm,
    clearEventDataItem,
    fetchEventDataList,
    fetchLocusGroupsList,
    fetchEventDataItem,
    showNotice,
    uploadFiles,
    removeFiles,
  },
)(injectIntl(Details))
